import { render, staticRenderFns } from "./AdminEmployees.vue?vue&type=template&id=260573f6"
import script from "./AdminEmployees.vue?vue&type=script&lang=js"
export * from "./AdminEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports